export function footerLogosReady() {
    if ($('#footerSummary .stats').length > 0) {
        $.ajax({
            dataType: 'jsonp',
            cache: 'true',
            url: baseCacheURL + 'about/impact.json',
            jsonpCallback: 'displayFooterStats',
        });
    }
}

// JSONP callback
window.displayFooterStats = function (data) {
    let dataString = '';
    dataString += '<div class="fluid-container"><div class="col col6 stat"><a target="_top" href="' + baseURL + 'about/impact.html"><span id="footer-stats-supporters">' + window.addCommas(data.stats.supporters) + '</span> supporters</a></div>';
    dataString += '<div class="col col6 stat"><a target="_top" href="' + baseURL + 'about/impact.html"><span id="footer-stats-teachers">' + window.addCommas(data.stats.projectsFunded) + '</span> projects funded</a></div>';
    if (dataString != '') {
        $('#footerSummary .stats').append(dataString);
    }
};
